// import { detectBrowserLanguage } from '@/components/shared/languageCodes';

// const browserLanguageCode = detectBrowserLanguage();

const state = {
  island: {
    musicEnabled: false,
  },
  lesson: {
    soundEnabled: true,
    needSlowSound: true,
    needMotivation: true,
    retryOption: false,
    retryIntro: {
      MADE_A_MISTAKE: false,
      MADE_LOT_MISTAKES: false,
    },
  },
  selectedLearnedLanguage: undefined,
  userSelectedLanguage: undefined,
  userOverwriteBrowserLanguagePersisted: false,
  userSelectedLevel: '',
  userSelectedGoal: '',
  isNotificationsEnabled: null,
  teachBotSpeed: undefined,
  startFromClass: undefined,
  needLastLearnedCard: true,
  proPopupType: undefined,
  isNexusUser: false,
  lastRoute: undefined,
  mobileSupportModalStatus: false,
  invalidationIsRunning: false,
  isPageNotFound: false,
  userSettings: {},
  dktOptions: {
    classId: undefined,
    fromDkt: undefined,
    dktAssignmentId: undefined,
    needIntroScreen: undefined,
  },
  windowWidthMobile: false,
  narratorLanguage: undefined,
  wcag: {
    optionallyBiggerCursor: false,
    contrastMode: false,
  },
  isKHUser: false,
};

export default state;
